import { modals } from '@mantine/modals';

import { useShowResponseStatus, useAppSelector } from '@/shared';
import { selectUserRole } from '@/modules/profile';
import {
  useApprovePaymentMutation,
  useDeclinePaymentMutation,
  useCancelPaymentMutation,
} from '../store/payments-api';
// import { handleApprovePaymentError } from '../utils/helpers/payments-errors';

import type { TPaymentApproveParams } from '../store/types';

export const usePaymentStatus = () => {
  const userRole = useAppSelector(selectUserRole);

  const [approvePayment, {
    isLoading: isApproveLoading,
    isSuccess: isApproveSuccess,
    isError: isApproveError,
  }] = useApprovePaymentMutation();

  const [declinePayment, {
    isLoading: isDeclineLoading,
    isSuccess: isDeclineSuccess,
    isError: isDeclineError,
  }] = useDeclinePaymentMutation();

  const [cancelPayment, {
    isLoading: isCancelLoading,
    isSuccess: isCancelSuccess,
    isError: isCancelError,
  }] = useCancelPaymentMutation();

  // Notifications
  useShowResponseStatus({
    isSuccess: isApproveSuccess,
    successMessage: 'Операция прошла успешно',
    isError: isApproveError,
    errorMassage: 'Что-то пошло не так, произошла ошибка!',
  });

  useShowResponseStatus({
    isSuccess: isDeclineSuccess,
    successMessage: 'Операция прошла успешно',
    isError: isDeclineError,
    errorMassage: 'Что-то пошло не так, произошла ошибка!',
  });

  useShowResponseStatus({
    isSuccess: isCancelSuccess,
    successMessage: 'Операция прошла успешно',
    isError: isCancelError,
    errorMassage: 'Что-то пошло не так, произошла ошибка!',
  });

  // Handlers
  const handleApprovePayment = async (params: TPaymentApproveParams) => {
    await approvePayment(params);
  };

  const handleDeclinePayment = (paymentId: number) => modals.openConfirmModal({
    title: 'Отклонение платежа',
    centered: true,
    children: `Вы уверены, что хотите отклонить платёж с ID ${paymentId}?`,
    labels: { confirm: 'Отклонить платёж', cancel: 'Отменить' },
    confirmProps: { color: 'red' },
    onConfirm: async () => await declinePayment({ paymentId }),
  });

  const handleCancelPayment = (paymentId: number) => modals.openConfirmModal({
    title: 'Отмена платежа',
    centered: true,
    children: `Вы уверены, что хотите отменить платёж с ID ${paymentId}?`,
    labels: { confirm: 'Отменить платёж', cancel: 'Закрыть' },
    confirmProps: { color: 'red' },
    onConfirm: async () => await cancelPayment({ paymentId }),
  });

  return {
    userRole,
    isApproveLoading,
    isDeclineLoading,
    isCancelLoading,
    handleApprovePayment,
    handleDeclinePayment,
    handleCancelPayment,
  };
};
